module.exports = __webpack_public_path__ + "static/media/push-image.0e977459.gif";